import React from 'react'

const AppliedInduction = () => {
  return (
    <div>AppliedInduction</div>
  )
}

export default AppliedInduction